
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { LinkedinIcon, XiaohongshuIcon, BilibiliIcon, YoutubeIcon } from "./SocialMediaIcons";

const Footer = () => {
  const { t } = useTranslation('footer');

  return (
    <footer className="bg-earth-800 text-white pt-12 pb-6" role="contentinfo" aria-label="Site footer">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-serif mb-4" role="heading" aria-level={3}>Resonow</h3>
            <p className="text-earth-300 mb-4">
              {t('tagline')}
            </p>
            <div className="flex space-x-4" role="list" aria-label="Social media links">
              <a 
                href="http://linkedin.com/company/resonow" 
                className="text-earth-300 hover:text-white transition-colors"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Resonow on LinkedIn"
                role="listitem"
              >
                <LinkedinIcon size={20} />
              </a>
              <a 
                href="https://www.xiaohongshu.com/user/profile/63e3d3dd0000000027028c96?xsec_token=YB69VkF1ScEtyl3APnzi4mfU_wUdQD2J6tJCMmyCbIroI=&xsec_source=app_share&xhsshare=CopyLink&appuid=63e3d3dd0000000027028c96&apptime=1748829819&share_id=4b83f0e9d7254de5930d6cd2ce16c2d6"
                className="text-earth-300 hover:text-white transition-colors"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Resonow on Xiaohongshu"
                role="listitem"
              >
                <XiaohongshuIcon size={20} />
              </a>
              <a href="#" className="text-earth-300 hover:text-white transition-colors" aria-label="Follow Resonow on Bilibili" role="listitem">
                <BilibiliIcon size={20} />
              </a>
              <a href="#" className="text-earth-300 hover:text-white transition-colors" aria-label="Follow Resonow on YouTube" role="listitem">
                <YoutubeIcon size={20} />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-4" role="heading" aria-level={3}>{t('support')}</h3>
            <nav aria-label="Footer navigation">
              <ul className="space-y-2 text-earth-300" role="list">
                <li>
                  <Link to="/about-us" className="hover:text-white transition-colors" aria-label="Learn about Resonow">{t('aboutUs')}</Link>
                </li>
                <li>
                  <Link to="/crisis-resources" className="hover:text-white transition-colors" aria-label="Crisis support resources">{t('crisisResources')}</Link>
                </li>
                <li>
                  <Link to="/careers" className="hover:text-white transition-colors" aria-label="Career opportunities at Resonow">{t('careers')}</Link>
                </li>
                <li>
                  <Link to="/privacy-policy" className="hover:text-white transition-colors" aria-label="Read our privacy policy">{t('privacyPolicy')}</Link>
                </li>
                <li>
                  <Link to="/terms-of-service" className="hover:text-white transition-colors" aria-label="Read our terms of service">{t('termsOfService')}</Link>
                </li>
                <li>
                  <Link to="/about-us" className="hover:text-white transition-colors" aria-label="Frequently asked questions">{t('faq')}</Link>
                </li>
                <li>
                  <Link to="/accessibility" className="hover:text-white transition-colors" aria-label="Learn about our accessibility features">{t('accessibility')}</Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        
        <div className="border-t border-earth-700 pt-6 mt-6 text-center text-earth-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Resonow. {t('copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
